
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VTEDASHSCORE',
components: {
XTable
},
data () {
return {
form: {
data1: '0',
data2: '0',
data3: '0',
data4: '0'
},
descTxt: ''
}
},
computed: {
score () {
let self = this
let form = JSON.parse(JSON.stringify(self.form))
console.log(form, 22)
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (form[key] !== '0') {
form[key] = 1
} else {
form[key] = 0
}
}
}
let result = form.data1 * 2 + form.data2 * 1 + form.data3 * 1 + form.data4 * (-2)
console.log(result, 777)
if (result <= 1) {
self.descTxt = '3.1%'
} else if (result > 1 && result <= 2) {
self.descTxt = '6.4%'
} else {
self.descTxt = '12.3%'
}
return result.toString()
}
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/VTEDASHSCORE.vue